import { Select } from "semantic-ui-react";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  behalfOfKeyValue,
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import { getBehalfOf } from "../../../api/systemUserApi";
import Button from "../../input/Button";
import { Search } from "react-feather";
import LoadingSpinner from "../../LoadingSpinner";
import Grid from "../../Grid";
import { ActiveCellStyle, StatusCellStyle } from "../../renderer/StyleRenderer";
import { stakeholderById } from "../../../api/stakeholderapi";
import {
  getUserCustomerByUserId,
  searchUserCustomer,
} from "../../../api/UserCustomerApi";
import Dropdown from "../../input/Dropdown";
import { searchCustomerShipper } from "../../../api/customerShipperAPI";

const CustomerShipperSearch = ({
  setCustomerShipperSearchRes,
  setCshSearchSubmitLoading,
  setCshSearchClicked,
}) => {
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);

  //search states
  const [customer, setCustomer] = useState("");
  const [shipper, setShipper] = useState("");
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [cluster, setCluster]= useState(null);
  //search dropdowns
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    (async () => {
      //new

      const { status, active } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);
    })();
  }, []);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setCshSearchSubmitLoading(true);
    setCshSearchClicked(true);

    const response = await searchCustomerShipper({
      cshShipper: shipper,
      cshCustomer: customer,
      cshStatus: status,
      cshActive: active,
      cshCluster:cluster,
    });

    setCustomerShipperSearchRes(response);
    // setSearchSubmitLoading(false);
    setCshSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    setSearchFieldReset([]);
    setStatus(null);
    setActive(null);
  };

  const handleReset = (e) => {
    e.preventDefault();
    handleSearchReset(e);
  };

  // useImperativeHandle(ref, () =>({
  //     getEditUserCustomer: () =>editUserCustomer,
  // }));
  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span>Search</span>
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>

            <i
              className="refresh icon primary button"
              style={{
                display: `${resetVisible ? "flex" : "none"}`,
                cursor: "pointer",
              }}
              onClick={(e) => {
                handleReset(e);
              }}
            ></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isSearchLoading ? (
            <LoadingSpinner />
          ) : (
            <form className="ui form">
              <h4 className="ui dividing header"></h4>
              <div className="four fields">
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setCustomer("");
                  }}
                  onResultSelect={(data) => setCustomer(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "customer",
                  }}
                  label="Customer"
                />
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setShipper("");
                  }}
                  onResultSelect={(data) => setShipper(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "shipper",
                  }}
                  label="Shipper"
                />
                 <SearchDropdown
                  key={1}
                  editMode={false}
                  field="csh_cluster"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setCluster("");
                  }}
                  onResultSelect={(data) =>
                    setCluster(data)
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "cluster",
                    value: "",
                  }}
                  label="Cluster"
                />
                <Dropdown
                  label="Status"
                  options={statusOptions}
                  placeholder="Status"
                  style={{ height: "20px" }}
                  value={status}
                  onChange={(e, data) => {
                    setStatus(data.value);
                  }}
                />
                <Dropdown
                  label="Active"
                  options={activeOptions}
                  placeholder="Active"
                  style={{ height: "20px" }}
                  value={active}
                  onChange={(e, data) => {
                    setActive(data.value);
                  }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button
                    template="search"
                    onClick={(e) => {
                      handleSearchSubmit(e);
                    }}
                  />
                  <Button
                    template="searchReset"
                    onClick={(e) => {
                      handleSearchReset(e);
                    }}
                  />
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};
export default CustomerShipperSearch;
